import React from "react";
import {
  convertThenFormat,
  fixedTwo,
  formatDateTimezon,
} from "../../../common-data/Converts";
import PaginationModified from "../../../../data/PaginationModified";

const ApplicableSubsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="all-followuo-info-container">
                  <div
                    className="lead-multi-value-cols"
                    style={{
                      padding: "20px",
                    }}
                  >
                    <div className="label-value">
                      <span className="label">incentive percentage</span>
                      <span className="value">
                        {row?.incentive_percentage || 0} %
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Total PT Sale</span>
                      <span
                        className="value link"
                        onClick={() =>
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardName: "total_PT_sale",
                            rowData: row,
                          }))
                        }
                      >
                        ₹{convertThenFormat(row?.purchase_month_sale || 0)}
                        <br />
                        <small className="underline gray">
                          {row?.purchase_month || "-"}/
                          {row?.purchase_year || "-"}
                        </small>
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Amount paid during purchase</span>
                      <span
                        className={`value ${row?.is_partial ? "link" : ""}`}
                        onClick={() =>
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardName: "partial_details",
                            partialDetails: row?.payment_details || [],
                          }))
                        }
                      >
                        ₹
                        {convertThenFormat(
                          row?.amount_paid_inpurchase_month || 0
                        )}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">paid Amount incentive</span>
                      <span className="value">
                        ₹
                        {convertThenFormat(
                          row?.paid_amount_byincentive_percentage || 0
                        )}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">per session cost</span>
                      <span className="value">
                        ₹{fixedTwo(row?.per_ssn_cost || 0)}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">completed session incentive</span>
                      <span className="value">
                        ₹{fixedTwo(row?.completed_ssn_incentive || 0)}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">session completion month</span>
                      <span className="value">
                        {row?.completed_ssn_month || "-"}/
                        {row?.completed_ssn_year || "-"}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">session status</span>
                      <span
                        className="value link"
                        onClick={() =>
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardName: "PT_sessions_details",
                            rowData: row,
                          }))
                        }
                      >
                        {row?.total_completed_ssn || 0}/
                        {row?.total_plan_session || 0}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">subscription duration</span>
                      <span className="value">
                        <small className="underline gray">
                          {row?.subs_date_added
                            ? formatDateTimezon(row.subs_date_added)
                            : "-"}
                        </small>
                        <br />
                        <small>
                          {row?.subs_start_date
                            ? formatDateTimezon(row.subs_start_date)
                            : "-"}
                          <br />
                          {row?.subs_expire_date
                            ? formatDateTimezon(row.subs_expire_date)
                            : "-"}
                        </small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default ApplicableSubsMobile;
